export const arrayOfObjects = (value) => {
  if (!(value instanceof Array)) {
    return false;
  }
  for (let item of value) {
    if (typeof item !== 'object') return false;
  }
  return true;
};
export const arrayOfStrings = (value) => {
  if (!(value instanceof Array)) {
    return false;
  }
  for (let item of value) {
    if (typeof item !== 'string') return false;
  }
  return true;
};
export const arrayOfObjectsWithProperties = (properties) => (value) => {
  if (!(value instanceof Array)) {
    return false;
  }
  for (let item of value) {
    for (let prop of properties) {
      if (item[prop] === undefined) return false;
    }
  }
  return true;
};
